<!--
   Created by qing on 2020/12/23
   Des: 文件预览弹窗 和 文件预览页面（/file/preview）一样
-->
<template>
  <van-popup
    class="file-preview-popup"
    v-model="visibleInfo.visible"
    :overlay="overlay"
    get-container="body"
    :style="{ height: popupHeight, width: '100%' }"
    :position="position">
    <div class="file-preview-page" v-if="previewFile">
      <div class="header">
        <div class="top">
          <svg class="icon" aria-hidden="true">
            <use :xlink:href="icon"></use>
          </svg>
          <div class="file-name">
            {{previewFile.fileName}}
            <span>({{previewFile.fileSize}}KB)</span>
          </div>
          <el-button size="small" @click="downloadFile">下载</el-button>
        </div>
        <div class="bottom">
          文件位置：{{filePosition}}
        </div>
      </div>
      <div class="loading-container" v-if="showLoading">
        <van-loading size="70px" vertical>加载中...</van-loading>
      </div>
      <div class="preview-container" v-if="!loading">
        <iframe
          v-if="!errorInfo"
          id="ifra"
          :key="previewUrl"
          :src="previewUrl"
          width="100%"
          height="100%"
          frameborder="0">
        </iframe>

        <div v-else class="error-page">
          <img :src="`${$BASE_PATH}/fetch/image?id=376459314291802113.png`" alt="">
          <p>{{errorInfo.info}}({{errorInfo.status}})</p>
        </div>
      </div>
    </div>
  </van-popup>
</template>

<script>
  import {fileType2FileImage} from "../../../assets/js/Untis";
  import {SUCCESS} from "../../store/types";
  import axios from 'axios'

  export default {
    props: {
      stackList: {
        type: Array,
        default: () => []
      },
      popupHeight: {
        type: String,
        default: '100%'
      },
      position: {
        type: String,
        default: 'right'
      },
      overlay: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        visibleInfo: {
          visible: false
        },
        previewFile: null,
        icon: '',
        filePosition: '',
        previewUrl: '',
        downloadEle: null,
        loading: true,
        errorInfo: null,
        showLoading: true
      }
    },
    created() {
    },
    methods: {
      open(file, preview_type) {

        this.showLoading = true
        this.previewUrl = ''
        this.errorInfo = null
        this.previewFile = file
        if (!this.downloadEle) {
          this.downloadEle = document.createElement('a')
          this.downloadEle.setAttribute('target', '_blank')
        }

        console.log('previewFile', this.previewFile)
        this.icon = fileType2FileImage(this.previewFile.fileType)
        if (preview_type === 'MIX_FORM') {
          this.filePosition = `${this.$store.getters.mix_form_name}>>${this.previewFile.fileName}`
        } else {
          this.filePosition = `表单>>${this.previewFile.fileName}`
        }


        if (this.$store.getters.userId) {
          this.$store.dispatch('actionFilePreviewUrl', {
            previewFile: {
              fileName: this.previewFile.fileName,
              fileSize: this.previewFile.fileSize,
              fileUrl: this.previewFile.fileUrl,
              fileType: this.previewFile.fileType,
              id: this.previewFile.id,
            }
          }).then(({status, resultObject, info}) => {
            if (status === SUCCESS) {
              this.previewUrl = resultObject.previewUrl
              setTimeout(() => {
                this.listenerIframeLoad()
              },200)
            } else {
              this.errorInfo = {
                status,
                info
              }
            }
          }).catch(console.error)
            .finally(() => {
              this.loading = false
            })
        } else {

          const url = `${location.origin}${this.$BASE_PATH}/api/real/ip`
          axios.post(url, {}).then(res => {
            return res.data
          }).then(({resultObject, status, info}) => {
            console.log('resultObject---', resultObject)
            return resultObject
          }).then(res => {
            console.log('actionGetRealIp', res)
            return this.$store.dispatch('actionFilePreviewOutUrl', {
              ipInfo: res.realIp || res.apaasRealIp,
              fileUrl: this.previewFile.fileUrl
            })
          }).then(({status, resultObject, info}) => {
            if (status === SUCCESS) {
              this.previewUrl = resultObject.previewUrl
              setTimeout(() => {
                this.listenerIframeLoad()
              },200)
            } else {
              this.errorInfo = {
                status,
                info
              }
            }
          }).catch(console.error)
            .finally(() => {
              this.loading = false
            })
        }


        this.stackList.push(this.visibleInfo)
        this.visibleInfo.visible = true
      },

      listenerIframeLoad() {
        this.$nextTick(() =>{
          const iframe = document.querySelector('#ifra')
          if (iframe.attachEvent) {
            this.showLoading = false
          } else {
            iframe.onload = () => {
              this.showLoading = false
            };
          }
        })
      },

      downloadFile() {
        if (window.isWexin || window.isWxWork || window.isLark) {
          this.$store.dispatch('reqNodeSave', this.previewFile).then(res => {
            this.$router.push({
              name: 'attDownload',
              query: {
                key: res.nodeKey
              }
            })
          }).catch(console.error)

        } else {
          if (this.downloadEle) {
            this.downloadEle.setAttribute('download', this.previewFile.fileName)
            if (this.$store.getters.userId) {
              this.downloadEle.setAttribute('href', `${this.previewFile.fileUrl}?userId=${this.$store.getters.userId}`)
            } else {
              this.downloadEle.setAttribute('href', this.previewFile.fileUrl)
            }
            this.downloadEle.click()
          }
        }
      }
    }
  }
</script>

<style lang="less">

  .file-preview-popup {

    .file-preview-page {
      width: 100%;
      height: 100%;
      position: relative;

      .header {
        height: 80px;
        width: 100%;
        background-color: #F5F7FA;
        padding: 10px 20px;

        .top {
          display: flex;
          align-items: center;
          margin-bottom: 10px;

          /*> i {*/
          /*  font-size: 24px;*/
          /*  margin-right: 10px;*/
          /*}*/

          .icon {
            width: 30px;
            height: 30px;
            vertical-align: -0.15em;
            fill: currentColor;
            overflow: hidden;
            margin-right: 10px;
          }

          .file-name {
            font-size: 20px;
            margin-right: 10px;
            flex: 1;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            word-wrap: break-word;

            span {
              font-size: 16px;
              color: #6d6d6d;
            }
          }
        }

        .bottom {
          font-size: 13px;
          color: #5d616f;
          width: 100%;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          word-wrap: break-word;
        }
      }

      .loading-container {
        position: absolute;
        top: 80px;
        left: 0;
        right: 0;
        bottom: 0;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .preview-container {
        position: absolute;
        top: 80px;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: transparent;
        z-index: 10;
      }
    }
  }
</style>